import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Club, clubService } from '../services/clubService';
import '../styles/ClubWalletHubPage.css';

const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(Number.isFinite(value) ? value : 0);

const ChevronIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DepositIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12 6v9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="m8 10 4-4 4 4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5 15.5a2.5 2.5 0 0 1 2.5-2.5h9a2.5 2.5 0 0 1 2.5 2.5v1A2.5 2.5 0 0 1 16.5 19h-9A2.5 2.5 0 0 1 5 16.5v-1Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const WithdrawIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12 18V9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="m8 13 4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5 8.5A2.5 2.5 0 0 1 7.5 6h9A2.5 2.5 0 0 1 19 8.5v1A2.5 2.5 0 0 1 16.5 12h-9A2.5 2.5 0 0 1 5 9.5v-1Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const ClubWalletHubPage: React.FC = () => {
  const navigate = useNavigate();
  const { clubId } = useParams<{ clubId: string }>();
  const [club, setClub] = useState<Club | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      if (!clubId) {
        setError('Club invalido para a area financeira.');
        return;
      }

      try {
        const payload = await clubService.getClub(clubId);
        if (!mounted) return;
        setClub(payload);
      } catch (nextError: any) {
        if (!mounted) return;
        setError(nextError?.message || 'Nao foi possivel carregar o club.');
      }
    };

    void load();
    return () => {
      mounted = false;
    };
  }, [clubId]);

  return (
    <div className="wallet-hub-page">
      <div className="wallet-hub-page__texture" />

      <header className="wallet-hub-topbar">
        <button type="button" className="wallet-hub-topbar__back" onClick={() => navigate('/clubs')}>
          Voltar
        </button>
        <button type="button" className="wallet-hub-topbar__logout" onClick={() => navigate('/clubs')}>
          Sair
        </button>
      </header>

      <main className="wallet-hub-main">
        {error ? <div className="wallet-hub-banner wallet-hub-banner--error">{error}</div> : null}

        {!error && (
          <section className="wallet-hub-summary">
            <article className="wallet-hub-summary__card wallet-hub-summary__card--club">
              <div className="wallet-hub-summary__club">
                <span>Club</span>
                <strong>{club?.name || 'Club'}</strong>
              </div>
              <div className="wallet-hub-summary__wallet">
                <span>Carteira neste club</span>
                <strong>{formatCurrency(Number(club?.current_user_wallet_balance || 0))}</strong>
              </div>
            </article>
          </section>
        )}

        <section className="wallet-hub-actions">
          <Link to={`/clubs/${clubId}/wallet/deposit`} className="wallet-hub-action wallet-hub-action--deposit">
            <span className="wallet-hub-action__icon wallet-hub-action__icon--deposit">
              <DepositIcon />
            </span>
            <div className="wallet-hub-action__copy">
              <strong>Deposito</strong>
              <span>Pix</span>
            </div>
            <ChevronIcon />
          </Link>

          <Link to={`/clubs/${clubId}/wallet/withdraw`} className="wallet-hub-action wallet-hub-action--withdraw">
            <span className="wallet-hub-action__icon wallet-hub-action__icon--withdraw">
              <WithdrawIcon />
            </span>
            <div className="wallet-hub-action__copy">
              <strong>Saque</strong>
              <span>Retirar</span>
            </div>
            <ChevronIcon />
          </Link>
        </section>
      </main>
    </div>
  );
};

export default ClubWalletHubPage;
